import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { Customer } from '../types';

export interface CurrencyBody {
  code: number;
  name: string;
  description: string;
  decimals: number;
}

export const cardsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCustomers: build.query<Response<Customer>, void>({
      query: () => ({
        url: '/v1/clients-organizations?type=INDIVIDUAL&all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const { useGetCustomersQuery, useLazyGetCustomersQuery } = cardsApi;

export const {
  endpoints: { getCustomers },
} = cardsApi;
